export const colunasEstoque = [
  {
    title: 'Produto/Touro',
    dataIndex: 'ProdutoNome',
    key: 'ProdutoNome'
  },
  {
    title: 'CodigoABS',
    dataIndex: 'CodigoFornecedor',
    key: 'CodigoFornecedor',
  },
  {
    title: 'Botijão',
    dataIndex: 'Botijao',
    key: 'Botijao'
  },
  {
    title: 'Raça',
    dataIndex: 'TouroRaca',
    key: 'TouroRaca'
  },
  {
    title: 'Rack',
    dataIndex: 'TouroRack',
    key: 'TouroRack'
  },
  {
    title: 'Semen',
    dataIndex: 'TouroSemenTipo',
    key: 'TouroSemenTipo'
  },
  {
    title: 'Tipo',
    dataIndex: 'ProdutoTipo',
    key: 'ProdutoTipo'
  },
  {
    title: 'Quantidade',
    className: 'text-right',
    dataIndex: 'Quantidade',
    key: 'Quantidade'
  }
]